// extracted by mini-css-extract-plugin
export default {"border":"styles_border__pqXKD"};